export const HeaderChatActiveChannelViewTestIds = {
  BACK: 'header-chat-channel.back-button',
};
